import styles from "./Marquee.module.css";

export interface MarqueeImage {
  src: string;
  alt: string;
}

interface MarqueeProps {
  images: MarqueeImage[];
  /** Seconds for one full loop. Higher = slower. Defaults to 60. */
  duration?: number;
  /** Scroll direction. Defaults to "left". */
  direction?: "left" | "right";
}

export function Marquee({ images, duration = 60, direction = "left" }: MarqueeProps) {
  if (images.length === 0) return null;
  // Duplicate the set so the track can loop seamlessly at -50%.
  const track = [...images, ...images];

  return (
    <div className={styles.marquee} role="presentation">
      <div
        className={`${styles.track} ${direction === "right" ? styles.reverse : ""}`}
        style={{ ["--marquee-duration" as string]: `${duration}s` }}
      >
        {track.map((img, i) => (
          <div className={styles.item} key={`${img.src}-${i}`} aria-hidden={i >= images.length}>
            <img src={img.src} alt={i < images.length ? img.alt : ""} loading="lazy" decoding="async" />
          </div>
        ))}
      </div>
    </div>
  );
}
